import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  /** Total number of steps */
  @Input() totalSteps: number = 6;
  /** Zero-based current step */
  @Input() currentStep: number = 0;

  get steps(): number[] {
    return Array.from({ length: this.totalSteps }, (_ :unknown, i :number) => i);
  }
}
